import React, { Component } from 'react';

export default class ExpectedAvailableDateOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
        this.props.handleDialog && this.props.handleDialog('ExpectedAvailableDateOverlayDialog', false);
    }

    componentDidMount() {
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog " + (this.state.showDialog ? "visible" : "hide")} id="actionDescriptionsOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                <a className="closeButton fontSize-10" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Expected Available Date</h2>
                    <div className="scroll-height-action-description">
    					<table className="dataTable">
    						<tbody>
    							<tr>
    								<td>The Expected Available Date is the date that the product is expected to be available at the shipping warehouse. 
                                    <br/>For SDS orders, this is the date it is expected to be at the SDS. This date is recalculated nightly.
                                    <br/>If the date is red, that indicates an expected miss to the Scheduled Arrival Date.
                                    <br/><br/><b>6+ mos:</b>   Model is currently in production, but demand exceeds all planned supply. “6+ mos.” indicates that the order has not been promised any of the existing supply, therefore we cannot provide an exact ETA date. The system estimate for availability under these conditions is that the order will reserve more than 6 months from today.
                                    <br/><br/><b>FP:</b> Model is past the final production date and there is no more supply being produced. “FP” indicates that the order has not been promised any remaining supply of the model. Order should be cancelled and replaced with an order for the new model.
                                    </td>
    							</tr>
    						</tbody>
    					</table>
                    </div>
            	</div>
			</div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/App/components/dialogs/expectedAvailableDateOverlayDialog.js